"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var Items_1 = __importDefault(require("./Items"));
var List = function (props) {
    var keys = props.keys, currentIndex = props.currentIndex, _a = props.list, list = _a === void 0 ? [] : _a;
    return (react_1.default.createElement("section", { className: (0, classnames_1.default)('list', {
            'list--entry': currentIndex === keys,
        }) },
        react_1.default.createElement("div", { className: "list__transition" }, list.map(function (items, index) {
            var imgUrl = items.imgUrl, hoverImgUrl = items.hoverImgUrl, title = items.title, describe = items.describe, link = items.link, _a = items.extendProps, extendProps = _a === void 0 ? {} : _a;
            return (react_1.default.createElement("div", __assign({ className: "list__items", key: "".concat(index, "-").concat(title) }, extendProps),
                react_1.default.createElement(Items_1.default, { imgUrl: imgUrl, hoverImgUrl: hoverImgUrl, title: title, describe: describe, link: link })));
        }))));
};
exports.default = List;
//# sourceMappingURL=List.js.map